import XAPPService from 'app/Core/services/XAPPService';

export const GET_MODELOS = '[FORMULARIO APP] GET MODELOS';
export const MODELO_INFO = '[MODELO APP] MODELO INFO';
export const MODELO_WARNING = '[MODELO APP] MODELO WARNING';
export const MODELO_ERROR = '[MODELO APP] MODELO ERROR';
export const MODELO_PASTAS = '[MODELO APP] MODELO PASTAS';

const ModeloListState =
    [
        'idmodelo',
        'descricao',
        'funcionalidade',
        'funcionalidadedescricao',
        'tipo',
        'conteudo',
        'usrins',
        'usrupt',
        'datainsdescricao',
        'datauptdescricao',
    ];

const ModeloAddState =
    [
        'idpessoa',
        'descricao',
        'tipo',
        'conteudo',
    ];

export function save(_AAction, _AState, _AParams, _AFilter = null) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        if (_AState.idmodelo !== null) {
            AConditionsAND.push({ Campo: "idmodelo", Operador: "=", Valor: _AState.idmodelo });
        }

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "modelo", _AAction, _AState, "idmodelo", AConditionsAND, AConditionsOR, 1, ModeloAddState);

        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: MODELO_WARNING,
                            payload: response.warning
                        })
                    ])
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: MODELO_INFO,
                            payload: response.info
                        })
                    ]).then(() => dispatch(list("SELECIONAR", _AParams, _AFilter)))
                }
            })
            .catch(error => {
                return dispatch({
                    type: MODELO_ERROR,
                    payload: error
                });
            });
    };
}

export function list(_AAction, _AParams, _AFilter = null) {

    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        if (_AFilter !== null) {
            if (_AFilter.AND !== undefined && _AFilter.AND !== null) {
                AConditionsAND = AConditionsAND.concat(_AFilter.AND);
            }

            if (_AFilter.OR !== undefined && _AFilter.OR !== null) {
                AConditionsOR = AConditionsOR.concat(_AFilter.OR);
            }
        }

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "Modelos", AActions, "spvwmodelo", ModeloListState, _AAction, AConditionsAND, AConditionsOR)

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_MODELOS,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: MODELO_ERROR,
                    payload: error
                });
            });
    };
}